class CartFreeShipping extends HTMLElement {
  connectedCallback() {
    this.animateProgress();
  }

  animateProgress() {
    const fill = this.querySelector('.cart-drawer__free-shipping-bar-fill');
    if (!fill) return;

    const scaleValue = Number.parseFloat(this.dataset.progressScale || '0');
    const safeScale = Number.isNaN(scaleValue) ? 0 : Math.max(0, Math.min(scaleValue, 1));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    fill.style.transform = `scaleX(${reducedMotion ? safeScale : 0})`;

    if (reducedMotion) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        fill.style.transform = `scaleX(${safeScale})`;
      });
    });
  }
}

if (!customElements.get('cart-free-shipping')) {
  customElements.define('cart-free-shipping', CartFreeShipping);
}
